(function () {
  function formatMoney(cents, format) {
    cents = parseInt(cents, 10) || 0;
    var formatString = format || '{{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = isNaN((precision = Math.abs(precision))) ? 2 : precision;
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;

      var value = (number / 100).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';

      return dollars + cents2;
    }

    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;

    switch (key) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return match ? formatString.replace(placeholderRegex, value) : value;
  }

  function initBundleBuilder(root) {
    if (root.dataset.bundleInitialized === 'true') return;
    root.dataset.bundleInitialized = 'true';

    var discountThreshold = parseInt(root.dataset.discountThreshold, 10) || 5;
    var discountPercent = parseInt(root.dataset.discountPercent, 10) || 0;
    var discountCode = root.dataset.discountCode || '';
    var moneyFormat = root.dataset.moneyFormat || '{{amount}}';
    var cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-card]'));

    var els = {
      incentive: root.querySelector('[data-bundle-incentive]'),
      progressFill: root.querySelector('[data-bundle-progress-fill]'),
      summaryList: root.querySelector('[data-summary-list]'),
      summaryEmpty: root.querySelector('[data-summary-empty]'),
      summaryTotals: root.querySelector('[data-summary-totals]'),
      subtotal: root.querySelector('[data-summary-subtotal]'),
      discountRow: root.querySelector('[data-summary-discount-row]'),
      discount: root.querySelector('[data-summary-discount]'),
      total: root.querySelector('[data-summary-total]'),
      savings: root.querySelector('[data-summary-savings]'),
      savingsAmount: root.querySelector('[data-savings-amount]'),
      ctaButton: root.querySelector('[data-bundle-add-to-cart]'),
      ctaLabel: root.querySelector('[data-cta-label]'),
      error: root.querySelector('[data-bundle-error]'),
    };

    var ctaDefaultLabel = els.ctaLabel ? els.ctaLabel.textContent : 'Add Bundle to Cart';

    var state = cards.map(function (card) {
      return {
        card: card,
        qty: 0,
        price: parseInt(card.dataset.price, 10) || 0,
        name: card.dataset.flavourName || '',
        variantId: card.dataset.variantId || '',
        available: card.dataset.available === 'true',
      };
    });

    function total() {
      return state.reduce(function (sum, item) {
        return sum + item.qty;
      }, 0);
    }

    function render() {
      var t = total();

      if (els.progressFill) els.progressFill.style.width = Math.min(t / discountThreshold, 1) * 100 + '%';

      if (els.incentive) {
        if (t >= discountThreshold) {
          els.incentive.textContent = discountPercent + '% discount unlocked';
          els.incentive.classList.add('is-unlocked');
        } else {
          var remaining = discountThreshold - t;
          var packWord = remaining === 1 ? 'pack' : 'packs';
          els.incentive.textContent = 'Add ' + remaining + ' more ' + packWord + ' to unlock ' + discountPercent + '% off';
          els.incentive.classList.remove('is-unlocked');
        }
      }

      state.forEach(function (item) {
        var valueEl = item.card.querySelector('[data-qty-value]');
        var decreaseBtn = item.card.querySelector('[data-qty-decrease]');
        var increaseBtn = item.card.querySelector('[data-qty-increase]');
        var badge = item.card.querySelector('[data-card-badge]');

        if (valueEl) valueEl.textContent = item.qty;
        item.card.classList.toggle('is-selected', item.qty > 0);
        if (badge) badge.hidden = item.qty === 0;
        if (decreaseBtn) decreaseBtn.disabled = item.qty === 0;
        if (increaseBtn) increaseBtn.disabled = !item.available;
      });

      var selected = state.filter(function (item) {
        return item.qty > 0;
      });

      if (els.summaryEmpty) els.summaryEmpty.hidden = selected.length > 0;
      if (els.summaryTotals) els.summaryTotals.hidden = selected.length === 0;
      if (els.ctaButton) els.ctaButton.hidden = selected.length === 0;

      if (els.summaryList) {
        Array.prototype.slice.call(els.summaryList.querySelectorAll('[data-summary-item]')).forEach(function (el) {
          el.remove();
        });

        selected.forEach(function (item) {
          var li = document.createElement('li');
          li.className = 'bundle-summary__item';
          li.setAttribute('data-summary-item', '');

          var nameSpan = document.createElement('span');
          nameSpan.textContent = item.name;

          var qtySpan = document.createElement('span');
          qtySpan.className = 'bundle-summary__item-qty';
          qtySpan.textContent = '×' + item.qty;

          li.appendChild(nameSpan);
          li.appendChild(qtySpan);
          els.summaryList.appendChild(li);
        });
      }

      var subtotal = selected.reduce(function (sum, item) {
        return sum + item.price * item.qty;
      }, 0);
      var discount = t >= discountThreshold ? Math.round((subtotal * discountPercent) / 100) : 0;
      var finalPrice = subtotal - discount;

      if (els.subtotal) els.subtotal.textContent = formatMoney(subtotal, moneyFormat);
      if (els.discount) els.discount.textContent = '-' + formatMoney(discount, moneyFormat);
      if (els.total) els.total.textContent = formatMoney(finalPrice, moneyFormat);
      if (els.savingsAmount) els.savingsAmount.textContent = formatMoney(discount, moneyFormat);
      if (els.discountRow) els.discountRow.hidden = discount <= 0;
      if (els.savings) els.savings.hidden = discount <= 0;
    }

    cards.forEach(function (card, index) {
      var item = state[index];
      var increaseBtn = card.querySelector('[data-qty-increase]');
      var decreaseBtn = card.querySelector('[data-qty-decrease]');

      if (increaseBtn) {
        increaseBtn.addEventListener('click', function () {
          if (!item.available) return;
          item.qty += 1;
          render();
        });
      }

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function () {
          if (item.qty === 0) return;
          item.qty -= 1;
          render();
        });
      }
    });

    if (els.ctaButton) {
      els.ctaButton.addEventListener('click', function () {
        var selected = state.filter(function (item) {
          return item.qty > 0;
        });
        if (selected.length === 0) return;

        var items = selected.map(function (item) {
          return { id: item.variantId, quantity: item.qty };
        });

        els.ctaButton.disabled = true;
        if (els.ctaLabel) els.ctaLabel.textContent = 'Adding...';
        if (els.error) els.error.hidden = true;

        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                var message = data.errors;
                if (message && typeof message === 'object') {
                  var key = Object.keys(message)[0];
                  message = message[key];
                  if (Array.isArray(message)) message = message[0];
                }
                throw new Error(message || data.description || data.message || 'Unable to add bundle to cart.');
              });
            }
            return response.json();
          })
          .then(function () {
            var redirectUrl = '/cart';
            if (discountCode) {
              redirectUrl = '/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart';
            }
            window.location.href = redirectUrl;
          })
          .catch(function (err) {
            els.ctaButton.disabled = false;
            if (els.ctaLabel) els.ctaLabel.textContent = ctaDefaultLabel;
            if (els.error) {
              els.error.textContent = err.message || 'Something went wrong. Please try again.';
              els.error.hidden = false;
            }
          });
      });
    }

    render();
  }

  function init() {
    document.querySelectorAll('[data-bundle-builder]').forEach(initBundleBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-bundle-builder]');
    if (root) initBundleBuilder(root);
  });
})();
